import '../list/gb-list.tag.html';
import './gb-sayt-link.tag.html';
import '../raw/gb-raw.tag.html';
riot.tag2('gb-sayt-refinements', '<h4>{displayName}</h4> <gb-list items="{values}"> <gb-sayt-link send="{_scope.searchRefinement}" data-value="{displayName}: {item}" data-refinement="{item}" data-field="{name}"> <yield> <gb-raw content="{_scope.highlightCurrentQuery(item, \'<b>$&</b>\')}"></gb-raw> </yield> </gb-sayt-link> </gb-list>', '.gb-stylish gb-sayt-refinements h4,.gb-stylish [riot-tag="gb-sayt-refinements"] h4,.gb-stylish [data-is="gb-sayt-refinements"] h4{ margin: 4px; }', '', function(opts) {

    this._scopeTo('gb-sayt');
});



/** WEBPACK FOOTER **
 ** ./src/tags/sayt/gb-sayt-refinements.tag.html
 **/